/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

const raw = PropTypes.shape({
  fields: PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  original: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
})

const rawList = PropTypes.shape({
  all: PropTypes.arrayOf({
    photo: raw.isRequired,
  }).isRequired,
})

const single = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
})

const list = PropTypes.arrayOf(single)

const photoShape = { raw, rawList, single, list }

export default photoShape

export const photoFragment = graphql`
  fragment Photo on ImageSharp {
    fields {
      title
      slug
    }
    original {
      src
      height
      width
    }
  }
`
